import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
import { PERMISSIONS } from '@tekion/tekion-base/constants/permissions';
import Spinner from '../../molecules/SpinnerComponent';
import withAsyncReducer from '../../connectors/withAsyncReducer';
import { REDUCER_NAME, SET_PERMISSIONS, SET_PERMISSIONS_ERROR } from './constants/permissions.constants';
import permissionsReducer from './reducers';
import PermissionContext from './PermissionContext';
import PermissionError from './PermissionError';
import fetchPermissions from './services/permissions.api';
var PermissionsProvider = /*#__PURE__*/function (_Component) {
  _inherits(PermissionsProvider, _Component);
  var _super = _createSuper(PermissionsProvider);
  function PermissionsProvider() {
    _classCallCheck(this, PermissionsProvider);
    return _super.apply(this, arguments);
  }
  _createClass(PermissionsProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var promise = fetchPermissions();
      var dispatch = this.props.dispatch;
      promise.then(function (response) {
        var persona = _get(response, 'data.data.persona');
        var permissions = _get(response, 'data.data.permissions') || EMPTY_ARRAY;
        if (persona === 'SuperAdmin') {
          permissions.push(PERMISSIONS.ADMIN.IS_ADMIN);
        }
        var success = _get(response, 'data.status');
        dispatch({
          type: SET_PERMISSIONS,
          payload: {
            permissions: permissions,
            success: success
          }
        });
      })["catch"](function () {
        dispatch({
          type: SET_PERMISSIONS_ERROR
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        permissions = _this$props.permissions,
        success = _this$props.success,
        loaded = _this$props.loaded,
        children = _this$props.children;
      return /*#__PURE__*/React.createElement(PermissionContext.Provider, {
        value: permissions
      }, success && children, !loaded && /*#__PURE__*/React.createElement("div", {
        className: "flex-center full-height full-width"
      }, /*#__PURE__*/React.createElement(Spinner, null)), !success && loaded && /*#__PURE__*/React.createElement(PermissionError, null));
    }
  }]);
  return PermissionsProvider;
}(Component);
_defineProperty(PermissionsProvider, "propTypes", {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  dispatch: PropTypes.func.isRequired,
  permissions: PropTypes.array.isRequired,
  success: PropTypes.bool.isRequired,
  loaded: PropTypes.bool.isRequired
});
var mapStateToProps = function mapStateToProps(state) {
  return state[REDUCER_NAME];
};
export default compose(withAsyncReducer({
  storeKey: REDUCER_NAME,
  reducer: permissionsReducer
}), connect(mapStateToProps))(PermissionsProvider);